import React, { useContext } from 'react';
import { Flex, Box, Icon, HStack, VStack, IconButton, Image } from '@chakra-ui/react';
import { FaInstagram, FaTiktok, FaCoffee, FaGlobe } from 'react-icons/fa';
import { Client } from '@foodfluence/shared';
import { ClientDataContext } from '../../../../contexts/ClientDataContext';
import { ff } from '../../../../theme';
import { DisplayHeading } from '../../../../components/ui';

interface BrandHeaderProps {
  campaign: any;
  client?: Client | null;
}

const SOCIAL_BUTTON = {
  w: '44px',
  h: '44px',
  minW: '44px',
  borderRadius: 'full',
  bg: ff.grey,
  color: ff.ink,
  _hover: { bg: ff.line },
} as const;

const BrandHeader: React.FC<BrandHeaderProps> = ({ campaign, client }) => {
  const clients = useContext(ClientDataContext);
  if (!client) {
    client = clients[campaign.clientID];
  }

  return (
    <Flex align="center" gap="14px" fontFamily="display">
      {client?.instagramProfilePicture ? (
        <Image
          src={client.instagramProfilePicture}
          alt="Brand logo"
          boxSize="56px"
          objectFit="cover"
          borderRadius="16px"
          flex="none"
          bg={ff.grey}
        />
      ) : (
        <Flex bg={ff.grey} borderRadius="16px" boxSize="56px" flex="none" align="center" justify="center">
          <Icon as={FaCoffee} color={ff.text2} boxSize={5} />
        </Flex>
      )}

      <VStack align="start" spacing="8px" flex={1} minW={0}>
        <Box wordBreak="break-word" overflowWrap="break-word">
          <DisplayHeading size="27px">{client?.accountName || 'Brand Name'}</DisplayHeading>
        </Box>
        {(client?.instagramHandle || client?.tiktokHandle || client?.website) && (
          <HStack spacing="8px">
            {client?.instagramHandle && (
              <IconButton
                aria-label="Open Instagram"
                icon={<Icon as={FaInstagram} boxSize="18px" />}
                {...SOCIAL_BUTTON}
                onClick={() => window.open(`https://instagram.com/${client!.instagramHandle}`, '_blank')}
              />
            )}
            {client?.tiktokHandle && (
              <IconButton
                aria-label="Open TikTok"
                icon={<Icon as={FaTiktok} boxSize="18px" />}
                {...SOCIAL_BUTTON}
                onClick={() => window.open(`https://tiktok.com/@${client!.tiktokHandle}`, '_blank')}
              />
            )}
            {client?.website && (
              <IconButton
                aria-label="Open website"
                icon={<Icon as={FaGlobe} boxSize="18px" />}
                {...SOCIAL_BUTTON}
                onClick={() => window.open(client!.website, '_blank')}
              />
            )}
          </HStack>
        )}
      </VStack>
    </Flex>
  );
};

export default BrandHeader;
